
$(document).ready(function(){
  var e = $('input[name="unit"]:checked').val();
  $(".weight, .height").attr("data-unit", e), $('input[name="unit"]').on("change", function() {
    e = $(this).val(), $(".weight, .height").attr("data-unit", e)
  });
  var  M = $(".macro-results");	
  var k = $("#macro-calculator-form");
  k.on("submit", function(e) {
    e.preventDefault();
    var t = !1,
        a = $(this),
        n = a.find('input[name="gender"]:checked').val(),
        r = a.find("input#birthday"),
        i = parseInt(r.val()),
        s = a.find('input[name="unit"]:checked').val(),
        o = a.find("input#weight-lbs"),
        u = a.find("input#weight-kg"),
        l = a.find("input#height-ft"),
        c = a.find("input#height-in"),
        h = a.find("input#height-cm"),
        d = "",
        f = "",
        p = "",
        g = 0;
    i != i || i < 1 ? (r.parent(".bday").addClass("error"), t = !0) : r.parent(".bday").removeClass("error"), "imperial" == s ? (d = parseInt(o.val()), d = parseInt(d / 2.20462), f = l.val(), p = c.val(), g = parseInt(12 * f) + parseInt(p), g = parseInt(30.48 * g / 12), d != d || d < 1 || isNaN(d) || "" == d ? (o.parent("label").addClass("error"), t = !0) : o.parent("label").removeClass("error"), f != f || f < 1 || isNaN(f) || "" == f ? (l.parent("label").addClass("error"), t = !0) : l.parent("label").removeClass("error"), p != p || p < 0 || isNaN(p) || "" == p ? (c.parent("label").addClass("error"), t = !0) : c.parent("label").removeClass("error")) : "metric" == s && (d = parseInt(u.val()), g = parseInt(h.val()), d != d || d < 1 || isNaN(d) || "" == d ? (u.parent("label").addClass("error"), t = !0) : u.parent("label").removeClass("error"), g != g || g < 1 || isNaN(g) || "" == g ? (h.parent("label").addClass("error"), t = !0) : h.parent("label").removeClass("error"));
    var m = 1.70462 * d,
        v = ("female" == n ? 10 * d + 6.25 * g - 5 * i - 161 : 10 * d + 6.25 * g - 5 * i + 5) * parseFloat(a.find('input[name="activity"]:checked').val());
    switch (fat = .35 * m, protein = .85 * m, carbs = (v - 4 * protein - 9 * fat) / 4, a.find('input[name="goal"]:checked').val()) {
      case "lose":
        var b = .2 * v;
        carbs = (v - 4 * protein - 9 * fat) / 4 - b / 4, v -= b;
        break;
      case "gain":
        b = .2 * v, protein = 1 * m, fat = .4 * m, carbs = (v - 4 * protein - 9 * fat) / 4 + b / 4, v += b
    }
    var C = Math.round(10 * protein) / 10,
        w = Math.round(10 * fat) / 10,
        y = Math.round(10 * carbs) / 10,
        I = Math.round(v);
    $("#result-protein").text(C), $("#result-fat").text(w), $("#result-carbs").text(y), $("#result-calories").text(I), M.addClass("vis"), 1 == t ? $("html,body").animate({
      scrollTop: k.offset().top - $(".site-header").outerHeight()
    }, 500) : $("html,body").animate({
      scrollTop: $("#macro-results").offset().top - 180
    }, 500)
  })
})